module.exports = __webpack_public_path__ + "static/media/work-experience-icon.6be88101.svg";